import styles from "./StaffHolidays.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";
import AllScheduledMovements from "../../sections/AllScheduledMovements/AllScheduledMovements";
import ProgramLevelMovements from "../../sections/ProgramLevelMovements/ProgramLevelMovements";
import FeeComponentSection from "../../sections/FeeComponentSection/FeeComponentSection";
import Discount from "../../sections/Discount/Discount";
import TaxRate from "../../sections/TaxRate/TaxRate";
import LeavePolicy from "../../sections/LeavePolicy/LeavePolicy";
import HolidayCalendar from "../../sections/HolidayCalendar/HolidayCalendar";
import WeekendConfiguration from "../../sections/WeekendConfiguration/WeekendConfiguration";

const StaffHolidays = () => {
  // default or make it dynamic later

  const handleFeeComponent = () => {
    dispatch(openModal("createFeeComponent"));
  };

  const handleAddDiscount = () => {
    dispatch(openModal("hodidayCalendar"));
  };

  const handleTaxrate = () => {
    dispatch(openModal("addTaxrate"));
  };

  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("Leave Policy");

  const tab = [
    {
      label: "Leave Policy",
      content: <LeavePolicy />,
    },
    {
      label: "Holiday Calendar",
      content: <HolidayCalendar />,
    },
    {
      label: "Weekend Configuration",
      content: <WeekendConfiguration />,
    },
  ];

  return (
    <>
      <div className={styles.background}>
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {/* <TabSwitch tabs={tab} /> */}
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
            {activeTab === "Leave Policy" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add"
                  bgColor="Primary_Color"
                  onClick={handleFeeComponent}
                />
              </div>
            )}
            {activeTab === "Holiday Calendar" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Holiday"
                  bgColor="Primary_Color"
                  onClick={handleAddDiscount}
                />
              </div>
            )}
            {activeTab === "Tax rate" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Add Tax rate"
                  bgColor="Primary_Color"
                  onClick={handleTaxrate}
                />
              </div>
            )}
          </div>
          {tab.map((item) =>
            activeTab === item.label ? <>{item.content}</> : null
          )}
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
};

export default StaffHolidays;
